<template>
  <div>
    <b-tooltip
      v-if="isNameLong"
      :title="name"
      :target="tooltipTargetId"
      placement="right"
      boundary=".menu"
    />
    <div
      :id="tooltipTargetId"
      class="sidebar-item-content"
    >
      <font-awesome-icon
        v-if="icon"
        class="menu-item-icon"
        :icon="icon"
      />
      <span
        :id="titleId"
        class="inner-text"
        v-html="formattedItemName"
      />
      <span
        v-if="badge"
        class="badge-wrapper"
      >
        <span
          class="badge"
          :class="badgeClasses"
        >{{ badge }}</span>
      </span>
    </div>
  </div>
</template>

<script>
import {highlightText} from '@/core/utils';

export default {
  name: 'SidebarItemContent',
  props: {
    badgeClasses: [String, Array],
    name: {
      type: String,
      required: true,
    },
    icon: [String, Array],
    searchKeyword: String,
    badge: Number,
  },
  computed: {
    isNameLong() {
      return this.name.length > 20;
    },
    tooltipTargetId() {
      return `navigation-item-${this.name}`;
    },
    titleId() {
      return `navigation-title-${this.name}`;
    },
    formattedItemName() {
      return highlightText(this.searchKeyword, this.name);
    },
  },
};
</script>

<style lang="scss" scoped>
.sidebar-item-content {
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
